import BootslideMenu from '../../components/bootslide/bootslide-menu'
import _ from 'lodash'
import i18n from '../../components/i18n'
import formHelper from '../../components/form-helper'
import Backbone from 'backbone'
import SizeMenuOption from '../../dashboards/widgets/wob-size-menu-option.hbs'
import positiveIntegerValidator from '../../components/validators/positive-integer-validator'
import numericRangeValidatorFactory from '../../components/validators/numeric-range-validator-factory'
import MarkedField from '../../components/marked-field'
import numericEvaluator from '../../components/evaluators/numeric-evaluator'

var MinMaxOption = Backbone.View.extend({

	initialize: function(opts={}) {
		this.options = opts
	},

	render: function() {
		this.$el.html(SizeMenuOption({
			label: i18n.get('charts.axis.' + this.options.type),
			placeholder: i18n.get('common.auto')
		}))

		let validator = [positiveIntegerValidator,
			numericRangeValidatorFactory(1,300, null,
			{ allowBlank: true })]
		if (this.options.type == 'max') {
			validator.push(() => {
				if (!this.options.hasValidMinMax()) {
					return i18n.get('charts.invalidMapDataSize')
				}
			})
		}
		this.markedField = new MarkedField({
			el: this.$('input'),
			validator,
			evaluator: numericEvaluator
		}).render()

		const inputName =
			`${this.options.settingType}${_.capitalize(this.options.type)}`
		this.$('input').attr('name', inputName)

		return this
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.markedField], 'remove')
	}
})

const MapDataSizeMenu = BootslideMenu.extend({

	initialize: function(opts={}) {
		this.options = opts
	},

	render: function() {
		BootslideMenu.prototype.render.apply(this, arguments)
		this.markedFields = _.map(this.childViews, v => v.markedField)
		this.$('input').on('input', this.applySettings.bind(this))
		formHelper.writeToDom(this.model, this.el)

		return this
	},

	menu: function() {
		const sizeOption = (type) => ({
			contentView: new MinMaxOption({
				type,
				settingType: this.options.settingType,
				hasValidMinMax: () => {
					const data = this.data()
					const min = data[`${this.options.settingType}Min`]
					const max = data[`${this.options.settingType}Max`]
					return !min || !max ||
						parseInt(min) <= parseInt(max)
				}
			}),
			label: `charts.axis.${type}`
		})
		return {
			label: i18n.get(`charts.chart.settingType.${this.options.settingType}`),
			target: [sizeOption('max'), sizeOption('min')],
			width: 200
		}
	},

	applySettings: function() {
		if (_.some(this.markedFields, field => !!field.validate())) {
			return
		}
		this.model.set(this.data())
	},

	data: function() {
		return formHelper.readFromDom(this.el)
	},
	
	remove: function() {
		BootslideMenu.prototype.remove.apply(this, arguments)
		_.invokeMap(this.markedFields, 'remove')
	}
})

export default MapDataSizeMenu
MapDataSizeMenu.__filename__ = 'charts/edit/map-data-size-menu.js'
